import React from 'react';
import { tierLabel, tierVariant } from './recipeBookConstants';
import {
	recipeBookPanelClassName,
	recipeBookTierBadgeBaseClassName,
	tierBadgeClassName
} from './recipeBookStyles';

export default function RecipeBookCard({ recipe, onOpen, isActive }) {
	const variant = tierVariant(recipe.health_tier);

	return (
		<button
			type="button"
			onClick={() => onOpen(recipe)}
			className={`${recipeBookPanelClassName} flex-shrink-0 w-56 sm:w-64 p-4 text-left transition-shadow hover:shadow-md ${
				isActive
					? 'ring-2 ring-inset ring-blue-500 dark:ring-blue-400 shadow-md'
					: ''
			}`}
		>
			<span
				className={`${recipeBookTierBadgeBaseClassName} ${tierBadgeClassName(variant)}`}
			>
				{tierLabel(recipe.health_tier)}
			</span>
			<h3 className="mt-1.5 text-sm font-semibold text-gray-900 dark:text-dark-text line-clamp-2">
				{recipe.title}
			</h3>
			{recipe.description ? (
				<p className="mt-1 text-xs text-gray-500 dark:text-gray-400 line-clamp-2">
					{recipe.description}
				</p>
			) : null}
			{recipe.save_count > 1 ? (
				<p className="mt-1.5 text-xs text-gray-400 dark:text-gray-500">
					Saved {recipe.save_count} times by the community
				</p>
			) : null}
		</button>
	);
}
